import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FormEntry from '../../../models/FormEntry'
import { observer } from 'mobx-react'
import { Divider, Form, Header, Segment } from 'semantic-ui-react'
import Input from '../Inputs/Input'
import Select from '../Inputs/Select'
import { Years, YesNo } from '../../../utils/FormSelectHelper'
import SelectMultiple from '../Inputs/SelectMultiple'
import Checkbox from '../Inputs/Checkbox'

@observer
class RIEBYX000 extends Component {
  static propTypes = {
    equipment: PropTypes.instanceOf(FormEntry),
    changeMenuType: PropTypes.func.isRequired
  }

  componentDidMount () {
    const { changeMenuType } = this.props
    changeMenuType('search', {
      label: 'Rechercher équipement par localisation',
      enableShowAll: true,
      searchFields: [
        { fieldName: 'localisation', isFixed: true }
      ]
    })
  }

  render () {
    const { equipment } = this.props
    return (
      <Segment>
        <Form>
          <Form.Group>
            <Input width={1} name='numero' formEntry={equipment} label='Numéro' isFixed />
            <Input width={5} name='localisation' formEntry={equipment} label='Localisation' isFixed />
            <Input width={10} name='notes' formEntry={equipment} label='Notes' />
          </Form.Group>
          <Form.Group>
            <Checkbox name='verificationEffectue' formEntry={equipment} label='Vérification effectué' />
          </Form.Group>
          <Divider />
          <Form.Group widths='equal'>
            <Select
              options={Years()} name='dateFabrication' formEntry={equipment}
              label='Date fabrication'
            />
            <Select
              options={Years()} name='dernierEssai' formEntry={equipment}
              label='Dernier essai'
            />
            <Input name='prochainEssai' formEntry={equipment} label='Prochain essai' isFixed />
          </Form.Group>
          <Divider />
          <Form.Group widths='equal'>
            <Select
              options={[{ text: 'A', value: 'a' }]} name='type' formEntry={equipment}
              label='Type'
              isFixed
            />
            <Select options={YesNo()} name='valve1' formEntry={equipment} label='Valve 1 &frac12;' />
            <Select options={YesNo()} name='valve2' formEntry={equipment} label='Valve 2 &frac12;' />
          </Form.Group>
          <Form.Group widths='equal'>
            <Select
              options={[{ text: '1 1/2', value: '11/2' }, { text: '2 1/2', value: '21/2' }]}
              name='format' formEntry={equipment}
              label='Format'
            />
            <Select
              options={[
                { text: "50'", value: '50' },
                { text: "75'", value: '75' },
                { text: "100'", value: '100' },
                { text: "150'", value: '150' },
                { text: "200'", value: '200' }
              ]} name='longueur' formEntry={equipment} label='Longueur'
            />
          </Form.Group>
          <Divider />
          <Header as='h3' content='Action' />
          <Form.Group widths='equal'>
            <SelectMultiple
              formEntry={equipment} options={[
                { value: 'action_lance', text: 'Lance' },
                { value: 'action_remplace', text: 'Remplacé' },
                { value: 'action_test', text: 'Test' },
                { value: 'action_neuf', text: 'Neuf' },
                { value: 'action_desuet', text: 'Désuet' },
                { value: 'action_celft', text: 'Clef T' },
                { value: 'action_vitre', text: 'Vitre' },
                { value: 'action_cabinet', text: 'Cabinet' },
                { value: 'action_seerrure', text: 'Serrure' },
                { value: 'action_supportpiano', text: 'Support piano' },
                { value: 'action_supportrealpack', text: 'Support realpack' },
                { value: 'action_supportpivotant', text: 'Support pivotant' },
                { value: 'action_couverture', text: 'Couverture' },
                { value: 'action_pictogramme', text: 'Pictogramme' },
                { value: 'action_taraton', text: 'Taraton' },
                { value: 'action_absent', text: 'Absent' },
                { value: 'action_difAccess', text: "Difficile d'accès" },
                { value: 'action_pasAccess', text: "Pas d'accès" }
              ]}
            />
          </Form.Group>

          <Divider />
          <Header as='h3' content='Recommandation' />
          <Form.Group widths='equal'>
            <SelectMultiple
              formEntry={equipment} options={[
                { value: 'recommandation_lance', text: 'Test' },
                { value: 'recommandation_remplace', text: 'Maintenance' },
                { value: 'recommandation_test', text: 'Lance' },
                { value: 'recommandation_neuf', text: 'Neuf' },
                { value: 'recommandation_desuet', text: 'Désuet' },
                { value: 'recommandation_celft', text: 'Clef T' },
                { value: 'recommandation_vitre', text: 'Vitre' },
                { value: 'recommandation_cabinet', text: 'Cabinet' },
                { value: 'recommandation_seerrure', text: 'Serrure' },
                { value: 'recommandation_supportpiano', text: 'Support piano' },
                { value: 'recommandation_supportrealpack', text: 'Support realpack' },
                { value: 'recommandation_supportpivotant', text: 'Support pivotant' },
                { value: 'recommandation_couverture', text: 'Couverture' },
                { value: 'recommandation_pictogramme', text: 'Pictogramme' },
                { value: 'recommandation_taraton', text: 'Taraton' }
              ]}
            />
          </Form.Group>
        </Form>
      </Segment>
    )
  }
}

export default RIEBYX000
